/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 17:52:30
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:11:30
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/PaymentGateway/AdyenItem.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import PasswordInput from '@/src/components/Password';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export default ({ handleResetInput, unlockEditable, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const { uuid } = params;
  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='merchantAccount'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.account',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.account'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='merchantID'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.merchantID',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.merchantID'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='apiKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n('storePayment.paymentEditPage.aPIKey')}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.aPIKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.aPIKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('apiKey')}
                  onEdit={() => handleResetInput('apiKey')}
                  passwordProps={{ maxLength: 512 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='clientKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.clientKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.clientKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.clientKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('clientKey')}
                  onEdit={() => handleResetInput('clientKey')}
                  passwordProps={{ maxLength: 100 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='hmacKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.hmacKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.hmacKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.hmacKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('hmacKey')}
                  onEdit={() => handleResetInput('hmacKey')}
                  passwordProps={{ maxLength: 100 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='urlPrefix'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={getI18n(
                      'storePayment.paymentEditPage.urlPrefixLabel',
                    )}
                  />
                }>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
        ]}
      />
    </Fragment>
  );
};
